import { createFileRoute, notFound } from "@tanstack/react-router";

import { ToolPage } from "../components/tools/ToolPage";
import { documentHeaders } from "../lib/seo";
import { loadToolLinks } from "../lib/toolLinks";
import { toolHead } from "../lib/tools/head";
import { loadToolCopy, toolBySlug } from "../lib/tools/index";
import { TOOLS_UI } from "../lib/tools/ui";

/**
 * One free tool, in English, at `/tools/<slug>`.
 *
 * The loader resolves the slug to a tool BEFORE loading any copy, so an unknown
 * slug is a 404 rather than a page rendered from `undefined`. That matters more
 * than usual here: the live v1 site answered every unknown path with a 200 and
 * the home page, which hid two broken internal links for months and burned
 * crawl budget on an unbounded URL space (docs/SEO-GEO-RESEARCH.md).
 */
export const Route = createFileRoute("/tools/$slug")({
  loader: async ({ params }) => {
    const tool = toolBySlug(params.slug);
    if (!tool) throw notFound();
    const [copy, links] = await Promise.all([
      loadToolCopy("en"),
      loadToolLinks(tool.slug, "en"),
    ]);
    return { tool, copy, links };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? toolHead(
          loaderData.tool.slug,
          "en",
          loaderData.copy[loaderData.tool.slug],
          TOOLS_UI.en,
        )
      : {},
  component: EnglishTool,
});

function EnglishTool() {
  const { tool, copy, links } = Route.useLoaderData();
  return (
    <ToolPage
      tool={tool}
      copy={copy[tool.slug]}
      ui={TOOLS_UI.en}
      lang="en"
      allCopy={copy}
      links={links}
    />
  );
}
